import React, { useState, useEffect } from "react";
import { Form, Select, Spin, Icon } from "antd";
import { createNoticeSetting } from "../../../../store/actions/actions";
import DefaultDatePicker from "./DefaultDatePicker";
import noticeTypeToRussian from "../../../../constants/noticeTypeToRussian";
import NoticeText from "./NoticeText";
import { useDispatch, useSelector } from "react-redux";
import getServiceCompanyEmail from "../../../../store/thunks/getServiceCompanyEmail";

const EmailSettings = ({ templates }) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);

	const currentCompany = useSelector(
    (store) => store.debtsStore.currentCompany
  );

	const [serviceCompanyEmails, setServiceCompanyEmails] = useState([]);
	const emailId = useSelector(
		(store) => store.debtsStore.createNotice.EmailId
	);
	useEffect(() => {
		if (serviceCompanyEmails?.length === 1) {
			dispatch(
				createNoticeSetting({ EmailId: serviceCompanyEmails?.[0]?.id })
			);
		}
	}, [serviceCompanyEmails]);

	useEffect(() => {
		(async () => {
			setLoading(true);
			setServiceCompanyEmails(await getServiceCompanyEmail(currentCompany?.id));
			setLoading(false);
		})();
	}, []);
	if (loading) {
		return (
			<Spin spinning={loading}>
				<div />
			</Spin>
		);
	}

	return (
		<div style={{ position: "relative" }}>
			<span className="type_name">{noticeTypeToRussian["EMAIL"]}</span>
			<Form.Item label="Адрес, с которого идет рассылка" colon={false}>
				<Select
					style={{ width: "200px" }}
					onChange={(value) =>
						dispatch(createNoticeSetting({ EmailId: value }))
					}
					value={emailId}
					defaultValue={emailId || serviceCompanyEmails?.[0]}
				>
					{serviceCompanyEmails?.map((serviceCompanyEmail) => {
						return (
							<Select.Option value={serviceCompanyEmail.id}>
								{serviceCompanyEmail.email}
							</Select.Option>
						);
					})}
				</Select>
			</Form.Item>
			<DefaultDatePicker type={"EMAIL"} />
			<NoticeText templates={templates} fieldKey="EmailTemplateId" />
		</div>
	);
};

export default EmailSettings;
